import _ from "lodash";
import idb from "./idb";

const eventTypes = {
  characterData: {
    target: {
      html: ({ element }) => element.innerHTML,
      text: ({ element }) => element.textContent,
    },
    handler: ({ docId, value, key }) => idb.fingerprints.put(docId, value, key),
  },
  attributes: {
    target: {
      position: ({ key }) => {
        const tbox = window?.pdfDoc?.getElementById(`tbox-id--${key}`);
        const pos = ("" + tbox.style.transform).match(/[0-9.]+/g);

        return { x: +pos[0] ?? 0, y: +pos[1] ?? 0 };
      },
      width: ({ key }) => {
        const tbox = window?.pdfDoc?.getElementById(`tbox-id--${key}`);
        return tbox.clientWidth - 26.46;
      },
      height: ({ key }) => {
        const tbox = window?.pdfDoc?.getElementById(`tbox-id--${key}`);
        return tbox.clientHeight - 5.2;
      },
      html: ({ element }) => element.innerHTML,
      text: ({ element }) => element.textContent,
    },
    handler: ({ docId, value, key, record }) => {
      idb.fingerprints.put(docId, value, key);
    },
  },
  childList: {
    target: {
      html: ({ element }) => element.innerHTML,
      text: ({ element }) => element.textContent,
    },
    handler: ({ docId, value, key }) => idb.fingerprints.put(docId, value, key),
  },
  insertText: {
    target: { action: () => "inserted" },
    handler: ({ docId, value, key }) => idb.fingerprints.put(docId, value, key),
  },
  deleteText: {
    target: { action: () => "deleted" },
    // handler: ({ docId, key }) => idb.fingerprints.del(docId, key),
    handler: ({ docId, value, key }) => idb.fingerprints.put(docId, value, key),
  },
  insertPage: {
    target: { action: () => "inserted" },
    handler: ({ docId, value, key }) => idb.assets.put(docId, value, key),
  },
  deletePage: {
    target: { action: () => "deleted" },
    handler: ({ docId, value, key }) => idb.assets.put(docId, value, key),
  },
  imageChange: {
    target: {},
    handler: ({ docId, value, key }) => idb.assets.put(docId, value, key),
  },
};

export const tracker = _.debounce(
  (stack, { docId, key, value = {}, element, pageId }) => {
    const filteredStack = (stack || []).filter((s) => s.type in eventTypes);
    const record = filteredStack[0];
    console.log(stack, docId, value, key);

    const $value = { mutated: 1, ...value };
    if (pageId) $value.pageid = pageId;

    const action = eventTypes[record.type];
    if (!action) return;

    for (let e in action.target) {
      $value[e] = action.target[e]({ key, element });
    }
    action.handler({ docId, value: $value, key, record });
  },
  200
);
